import Link from 'next/link';
import React, { FC } from 'react';

import { Anchor, Stack, Text } from '@mantine/core';

import { Component } from 'models';
import { ComponentHelpers } from 'helpers/ComponentHelpers';

import { ComponentThumbnail } from 'components/thumbnail/ComponentThumbnail';
import { useComponentMeta } from 'hooks/use-component-meta';

import cx from './ComponentOverviewHit.Simple.module.scss';

type Props = {
    component: Component;
    href?: string;
    rightSide?: React.ReactNode;
    target?: HTMLAnchorElement['target'];
    onClick?: (event: React.MouseEvent) => void;
};

const ComponentOverviewHitSimple: FC<Props> = ({ component, href: href_, rightSide, target = '_blank', onClick }) => {
    const { uniqueName, subtitle, slug } = useComponentMeta(component);

    const href = href_ ? href_ : component?.id ? ComponentHelpers.urls.view(component.id, slug) : undefined;
    const hasWrapperLink = Boolean(!rightSide && href);

    return (
        <Anchor
            component={hasWrapperLink ? Link : undefined}
            href={hasWrapperLink && href ? href : ''}
            className={cx.root}
            target={target}
            onClick={onClick}
        >
            <ComponentThumbnail
                showEmpty
                component={component as Component}
                style={{ width: 40, padding: 2, border: '1px solid var(--mantine-color-gray-2)', flex: 'auto 0 0' }}
            />
            <Stack gap={0}>
                {hasWrapperLink ? (
                    <Text fz="xs" c="primary">
                        {uniqueName}
                    </Text>
                ) : href ? (
                    <Text component={Link} href={href} fz="xs" c="primary">
                        {uniqueName}
                    </Text>
                ) : (
                    <Text fz="xs">{uniqueName}</Text>
                )}

                <Text fz="xs" c="dimmed">
                    {subtitle}
                </Text>
            </Stack>
            {rightSide}
        </Anchor>
    );
};

export { ComponentOverviewHitSimple };
